const SETUP_DISMISS_KEY = 'wapharma:setup:dismissed';

function scopedKey(base: string, userId: string | undefined): string {
  return userId ? `${base}:${userId}` : base;
}

/** Soft « Plus tard » — hide auto-open until reopen from Paramètres. */
export function isSetupDismissed(userId: string | undefined): boolean {
  try {
    return localStorage.getItem(scopedKey(SETUP_DISMISS_KEY, userId)) === '1';
  } catch {
    return false;
  }
}

export function setSetupDismissed(userId: string | undefined, dismissed: boolean): void {
  try {
    const key = scopedKey(SETUP_DISMISS_KEY, userId);
    if (dismissed) localStorage.setItem(key, '1');
    else localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}
